module.exports = __webpack_public_path__ + "static/img/MT4.f7f1f3ce.png";